import { render, staticRenderFns } from "./critical.vue?vue&type=template&id=1dca4761&scoped=true"
import script from "./critical.vue?vue&type=script&lang=js"
export * from "./critical.vue?vue&type=script&lang=js"
import style0 from "./critical.vue?vue&type=style&index=0&id=1dca4761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dca4761",
  null
  
)

export default component.exports